import 'jspdf-autotable'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'

import {TransactionsListWrapper} from './transactions-list/TransactionsList'

const TransactionsPage = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route path='transactions' element={<TransactionsListWrapper />} />
        </Route>
        <Route index element={<Navigate to='/report' />} />
      </Routes>
    </>
  )
}

export default TransactionsPage
